module.exports = __webpack_public_path__ + "img/2.01ade5c0.png";